import { css } from '@eti/styles';
import { Button, Card, Heading } from '@etg/wings';
import { LoadingDots, variants } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { cancelForAnyReason, flexibleTicket } from '@eti/products';
import type { TicketCardV1Props } from '../../model';
import { TICKET_TYPES } from '../../constants';
import { TicketReadMore } from '../common/TicketReadMore';
import { TicketPriceInfo } from '../common/TicketPriceInfo';
import { TicketInformation } from './common/TicketInformation';

const cardStyles = css`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const cardSectionWrapperStyles = css`
  border: none;
`;

const cardSectionStyles = css`
  padding: 16px 0 0;
`;

const cardSectionTopStyles = css`
  padding: 0 0 16px;
`;

const cardSectionV1Styles = css`
  margin-top: auto;
  padding-top: 0;
`;

const buttonStyles = css`
  width: 100%;
`;

export const TicketCardV1 = ({
  isLoading,
  isRyanAirTicketingOrMarketingCarrierPresent,
  isVI,
  onClick,
  selectedTicketType,
  ticket,
  ticketPriceModalInfo,
}: TicketCardV1Props) => {
  const { t } = useTranslation();
  const { ticketTitle, ticketType } = ticket;
  let ticketId;
  const { CANCEL_FOR_ANY_REASON_TICKET, FLEXIBLE_TICKET } = TICKET_TYPES;
  switch (ticketType) {
    case CANCEL_FOR_ANY_REASON_TICKET:
      ticketId = cancelForAnyReason.id;
      break;
    case FLEXIBLE_TICKET:
      ticketId = flexibleTicket.id;
      break;
    default:
      break;
  }
  return (
    <Card className={cardStyles} data-testid={`ticket-${ticketType}`}>
      <Card.Section>
        <Heading level={2}>{ticketTitle}</Heading>
      </Card.Section>
      <Card.Section className={cardSectionWrapperStyles}>
        <Card className={cardStyles}>
          <Card.Section className={cardSectionTopStyles}>
            <TicketPriceInfo
              isRyanAirTicketingOrMarketingCarrierPresent={
                isRyanAirTicketingOrMarketingCarrierPresent
              }
              isVI={isVI}
              ticket={ticket}
              ticketPriceModalInfo={ticketPriceModalInfo}
              ticketVersion={1}
            />
          </Card.Section>
          <Card.Section className={cardSectionStyles}>
            <TicketInformation ticketType={ticketType} ticketVersion={1} />
            <TicketReadMore ticketId={ticketId} />
          </Card.Section>
        </Card>
      </Card.Section>
      <Card.Section className={cardSectionV1Styles}>
        <Button
          className={buttonStyles}
          data-testid="resultPage-book-button"
          onClick={() => onClick(ticketType)}
          variant={variants.PRIMARY}
        >
          {isLoading && selectedTicketType === ticketType ? (
            <LoadingDots />
          ) : (
            t('Result.BookButton.Default.Text')
          )}
        </Button>
      </Card.Section>
    </Card>
  );
};
